module.exports = __webpack_public_path__ + "img/blueResume.f012d3ed.svg";